import { VbzInputText } from '@smiles/voebiz-ui-kit';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import debounce from 'lodash/debounce';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchIcon } from '../..';

const HistoryBatchSearch = () => {
  const { setFilter, filter, setTab, tab, setFilterSearchInput, filterSearchInput } = useHistoryBatch();

  const { t } = useTranslation('beneficiaries');

  const handleFilterChange = debounce((search?: string) => {
    setFilterSearchInput(search);
  }, 800);

  const handleCleanFilter = () => {
    setFilterSearchInput('');
  };

  const handleAddMemberTab = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete('active');
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    setTab('_AT');
    setFilter({ ...filter, search: '_AT' });
  };

  const isIncludeOneBeneficiary = tab === '_AT';

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const p = params.get('p');
    const active = params.get('active');

    if (p === 'historico-importacoes' && tab !== '_DS' && active === 'desativacao') {
      setTab('_DS');
      setFilter({ ...filter, search: '_DS' });
    }
  }, []);

  return (
    <div className="w-100 container-table-header beneficiaries-table-wrapper">
      <div className="include-modal-container history">
        <div className="tabs">
          <span className={isIncludeOneBeneficiary ? 'tab-title-active' : 'tab-title'} onClick={handleAddMemberTab}>
            Inclusão
          </span>
          <span
            className={!isIncludeOneBeneficiary ? 'tab-title-active' : 'tab-title'}
            onClick={() => {
              setTab('_DS');
              setFilter({ ...filter, search: '_DS' });
            }}
          >
            Desativação
          </span>
        </div>
      </div>
      <div className="w-100 search-input-container">
        <VbzInputText
          className="input-search"
          value={filterSearchInput}
          onChange={({ target }) => handleFilterChange(target.value)}
          placeholder={t('search')}
          icon={
            <>
              {filterSearchInput && (
                <button
                  type="button"
                  className="icon-clear"
                  data-testid="button-clear-search"
                  onClick={() => handleCleanFilter()}
                >
                  <i className="material-icons">close</i>
                </button>
              )}
              <SearchIcon />
            </>
          }
        />
      </div>
    </div>
  );
};

export default HistoryBatchSearch;
